import { connect } from '@ardoq/rxbeach';
import { AssistantChatFooter } from './AssistantChatFooter';
import { chatFooterViewModel$ } from './chatFooterViewModel$';
import { memo } from 'react';

export const ConnectedChatFooter = memo(
  connect(AssistantChatFooter, chatFooterViewModel$)
);
